import React, {Component} from "react";
import Style from "./FJBorder.module.less";

class FJBorder extends Component {
  render() {
    return (
      <div className={Style.ratio_preview_box}/>
    )
  }
}

export default FJBorder;
